import { EntityModel } from '@/interfaces'
import {
  ALL_WEBHOOK_CONFIGS_QUERY,
  CREATE_WEBHOOK_CONFIG_MUTATION,
  DELETE_WEBHOOK_CONFIG_MUTATION,
  FORCE_DELETE_WEBHOOK_CONFIG_MUTATION,
  SINGLE_WEBHOOK_CONFIG_QUERY,
  UPDATE_WEBHOOK_CONFIG_MUTATION,
} from './graphql'

const travelWebhookConfigModel: EntityModel = {
  name: 'webhookConfig',
  namePlural: 'webhookConfigs',
  uniqueName: 'travelWebhookConfig',
  uniqueNamePlural: 'travelWebhookConfigs',
  path: 'travel/pricing/webhook_config',
  baseUrl: '/travel/pricing/webhook_configs',
  translationPrefix: 'entities:travelWebhookConfig.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_WEBHOOK_CONFIGS_QUERY,
    getSingle: SINGLE_WEBHOOK_CONFIG_QUERY,
    create: CREATE_WEBHOOK_CONFIG_MUTATION,
    update: UPDATE_WEBHOOK_CONFIG_MUTATION,
    delete: DELETE_WEBHOOK_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_WEBHOOK_CONFIG_MUTATION,
  },
  attributes: {
    enabled: {
      name: 'enabled',
      label: 'entities:travelWebhookConfig.attributes.enabled.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    url: {
      name: 'url',
      label: 'entities:travelWebhookConfig.attributes.url.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'url',
        },
      ],
    },
  },
}

export default travelWebhookConfigModel
